import React,{useState} from "react";
import StudionNav from "../Header/StudioNav";
import UploadStudio from "./UploadStudioModel";
import Grid from "@mui/material/Grid";
import VideoComponent from "./VideoComponent";
import CameraControls from "./CameraControls";


export default function Studio() {
    const [videoShot, setVideoShot] = React.useState(false);
    const [image, setImage] = React.useState<string | null>(null);
    const [uploadfile, setUploadFile] = useState([])
    const [prompt, setPrompt] = useState<string>("");
    const [videoData, setVideoData] = useState<any>([]);
    const [openPopover, setOpenPopover] = useState<boolean | undefined>(false);
    return (
        <div>
            <StudionNav />
            <Grid
                container
                spacing={2}
                className="mainContainerStudio"
                direction={"row"}
                
            >
                <Grid item xs={12} sm={6} lg={3.5} xl={3.5}  height={'100%'}>
                    <UploadStudio image={image} setImage={setImage} setUploadFile={setUploadFile} uploadfile={uploadfile} setPrompt={setPrompt} prompt={prompt} setVideoData={setVideoData} videoData={videoData} setOpenPopover={setOpenPopover} openPopover={openPopover}/>
                </Grid>
                <Grid item xs={12} sm={5.5} lg={4.5} xl={5} className="">
                    <VideoComponent image={image} setImage={setImage} videoData={videoData} prompt={prompt} setPrompt={setPrompt}/>
                </Grid>
                <Grid item xs={12} sm={6} lg={4} xl={3.5} className="">
                    <CameraControls setVideoShot={setVideoShot} videoShot={videoShot} image={image} prompt={prompt} setPrompt={setPrompt} uploadfile={uploadfile}/>
                </Grid>
            </Grid>
              
        </div>
    );
}
